// IE 2026 11 03 / ODOO-350449 (webscm #128539: обработчики document подсказки сигнала): клик по строке проблемы и полный текст обрезанной строки в подсказке над сигналом
// (AttrGrid.signalTip_tipClick / signalTip_tipOver) слушают document в фазе захвата. Было: каждый грид ставил свою пару слушателей (снимались в beforeUnmount),
// на столе из N гридов — 2N обработчиков на каждый click / mouseover страницы. Стало: одна пара на документ со счётчиком гридов; событие уходит только гриду,
// чья подсказка под курсором (data-sig-grid корня .sig-tip), mouseover — ещё и гриду прошлого наведения (снять у него раскрытую строку). Ушёл последний грид — пара снята.
// Выключатель fe.ux.signalTipDocListenersShared (дефолт ВКЛ; false — своя пара у каждого грида, как было). Чистая логика без Vue — tests/unit/signalTipDoc.test.mjs

export const SIGNAL_TIP_DOC_SHARED_FLAG = 'fe.ux.signalTipDocListenersShared'

const REG = new WeakMap()   // document → { grids: Map uid → { click, over }, last, onClick, onOver }
export const stats = { installs: 0, removals: 0, active: 0 }
if (typeof window !== 'undefined') window.__sigTipDoc = stats   // счётчики для проб

// uid грида подсказки под целью события ('' — не подсказка сигнала)
export function signalTipDoc_uidOf(target) {
    try {
        const root = target && typeof target.closest === 'function' ? target.closest('.sig-tip') : null
        return root ? String(root.getAttribute('data-sig-grid') || '') : ''
    } catch (e) { return '' }
}

// зарегистрировать грид uid с обработчиками { click(e), over(e) }; возвращает функцию снятия
export function signalTipDoc_register(doc, uid, h) {
    if (!doc || typeof doc.addEventListener !== 'function' || !uid || !h) return () => {}
    let st = REG.get(doc)
    if (!st) {
        st = { grids: new Map(), last: '', onClick: null, onOver: null }
        st.onClick = (e) => {
            const g = st.grids.get(signalTipDoc_uidOf(e && e.target))
            if (g && g.click) { try { g.click(e) } catch (err) { /* подсказка ушла */ } }
        }
        st.onOver = (e) => {
            const u = signalTipDoc_uidOf(e && e.target)
            const prev = st.last
            st.last = u
            if (prev && prev !== u) { const p = st.grids.get(prev); if (p && p.over) { try { p.over(e) } catch (err) { /* подсказка ушла */ } } }
            const g = u ? st.grids.get(u) : null
            if (g && g.over) { try { g.over(e) } catch (err) { /* подсказка ушла */ } }
        }
        doc.addEventListener('click', st.onClick, true)
        doc.addEventListener('mouseover', st.onOver, true)
        REG.set(doc, st)
        stats.installs++
    }
    const key = String(uid)
    st.grids.set(key, h)
    stats.active = st.grids.size
    return () => {
        const cur = REG.get(doc)
        if (!cur || cur.grids.get(key) !== h) return
        cur.grids.delete(key)
        if (cur.last === key) cur.last = ''
        stats.active = cur.grids.size
        if (!cur.grids.size) {
            doc.removeEventListener('click', cur.onClick, true)
            doc.removeEventListener('mouseover', cur.onOver, true)
            REG.delete(doc)
            stats.removals++
        }
    }
}

// число зарегистрированных гридов документа (для тестов и проб)
export function signalTipDoc_count(doc) { const st = doc ? REG.get(doc) : null; return st ? st.grids.size : 0 }
